import React, { useState , useEffect } from "react";
import DropDown from "../../Helpers/DropDown";
import SliderCom from "../../Helpers/SliderCom";
import { getsocialfeed2 } from "../../../Services/service";
import block1 from "../../../assets/images/News/block1.jpg";
import block2 from "../../../assets/images/News/block2.jpeg";
import block3 from "../../../assets/images/News/block3.jpeg";
import icon4 from "../../../assets/images/icon/icon-4.png";
import postbar from "../../../assets/images/icon/post-bars.png";
import latestp1 from "../../../assets/images/News/latest-post-11.jpeg";
import latestp2 from "../../../assets/images/News/latest-post-12.jpeg";
import latestp3 from "../../../assets/images/News/latest-post-13.jpeg";
import newyear from "../../../assets/images/News/newyear.jpeg";
function AuthorSection() {
  const category1 = ["Web Developement", "UI/UX", "Programming", "reactjs"];
  const [selectedCategory, setCategory] = useState(category1[0]);
  const changeCategory1 = (value) => {
    setCategory(value);
  };
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    speed: 1500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1201,
        settings: {
          arrows: false,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 992,
        settings: {
          arrows: false,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 1,
        },
      },
    ],
  };
   const [feedata1, setFeedata1] = useState();
    useEffect(() => {
        loadData();
      }, []);
    
      async function loadData() {
        const fn1 = await getsocialfeed2();
        setFeedata1(fn1); 
        // console.log(fn1)
      }
      // console.log(feedata1 )
  return (
    <>
      <section className="binduz-er-author-item-area pb-20">
      {feedata1 && feedata1.feedinfo1.map((item)=>{
          return(
        <div className=" container">
          <div className="row">
            <div className=" col-lg-9">
              <div className="binduz-er-author-item mb-40">
                {/* <div className="binduz-er-thumb">
                  <img
                    src={
                      require(`../../../assets/images/author-item-1.jpg`)
                        .default
                    }
                    alt=""
                  />
                </div> */}
                <div className="binduz-er-content">
                  <div className="binduz-er-meta-item">
                    <div className="binduz-er-meta-categories">
                      <a href="#">{item.news}</a>
                    </div>
                    <div className="binduz-er-meta-date">
                      <span>
                        <i className="fal fa-calendar-alt"></i>{item.date}
                      </span>
                    </div>
                  </div>
                  <h3 className="binduz-er-title">
                    {item.title}
                  </h3>
                  <div className="binduz-er-meta-author">
                    <div className="binduz-er-author">
                      <img
                        src={
                          require(`../../../assets/images/user-2.jpg`).default
                        }
                        alt=""
                      />
                      <span>
                        <span>{item.author}</span>
                      </span>
                    </div>
                    <div className="binduz-er-meta-list">
                      <ul>
                        <li>
                          <i className="fal fa-eye"></i> {item.view}
                        </li>
                        <li>
                          <i className="fal fa-heart"></i> {item.view}
                        </li>
                        <li>
                          <i className="fal fa-comments"></i> {item.view}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="binduz-er-blog-details-box">
                  <div className="binduz-er-text">
                    <p>
                      {item.p1}
                    </p>
                    <p>
                      {item.p2}
                    </p>
                  </div>
                  <div className="row">
                    <div className=" col-lg-6">
                      <div className="binduz-er-blog-details-thumb mt-25">
                        <img
                          src={
                            require(`../../../assets/images/blog-details-thumb-1.jpg`)
                              .default
                          }
                          alt=""
                        />
                      </div>
                    </div>
                    <div className=" col-lg-6">
                      <div className="binduz-er-blog-details-thumb mt-25">
                        <img
                          src={
                            require(`../../../assets/images/blog-details-thumb-2.jpg`)
                              .default
                          }
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                  <div className="binduz-er-text mt-50">
                    <p>
                      {item.p3}
                    </p>
                  </div>
                  <div className="binduz-er-quote-text">
                    <p>
                      {item.p4}
                    </p>
                    <span>
                      <span>{item.author}</span>
                    </span>
                  </div>
                  <div className="binduz-er-text mt-50">
                    <p>
                      {item.p5}
                    </p>
                    <ul>
                      <li>
                        {item.p6}
                      </li>
                      <li>{item.p7}</li>
                      <li>
                       {item.p8}
                      </li>
                    </ul>
                  </div>
                  <div className="row align-items-center pt-60">
                    <div className=" col-lg-3">
                      <div className="binduz-er-blog-details-thumb">
                        <img
                          src={
                            require(`../../../assets/images/blog-details-thumb-3.jpg`)
                              .default
                          }
                          alt=""
                        />
                      </div>
                    </div>
                    <div className=" col-lg-6">
                      <div className="binduz-er-blog-details-thumb-text text pl-10 pr-25 pt-20 pb-20">
                        <p>
                          {item.p8}
                        </p>
                      </div>
                    </div>
                    <div className=" col-lg-3">
                      <div className="binduz-er-blog-details-thumb">
                        <img
                          src={
                            require(`../../../assets/images/blog-details-thumb-4.jpg`)
                              .default
                          }
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                  <div className="binduz-er-text pt-50">
                    <p>
                      {item.p2}
                    </p>
                  </div>
                  <div className="binduz-er-blog-details-thumb-play mt-50">
                    <img
                      src={
                        require(`../../../assets/images/blog-details-thumb-5.jpg`)
                          .default
                      }
                      alt=""
                    />
                    <div className="binduz-er-play">
                      <a className="binduz-er-video-popup" href="#">
                        <i className="fas fa-play"></i>
                      </a>
                    </div>
                  </div>
                  <div className="binduz-er-text mt-50">
                    <p>
                      {item.p3}
                    </p>
                  </div>
                  <div className="binduz-er-social-share-tag d-block d-sm-flex justify-content-between align-items-center">
                    <div className="binduz-er-tag">
                      <ul>
                        <li>
                          <a href="#">{item.adop1}</a>
                        </li>
                        <li>
                          <a href="#">{item.adop2}</a>
                        </li>
                        <li>
                          <a href="#">{item.adop3}</a>
                        </li>
                      </ul>
                    </div>
                    <div className="binduz-er-social">
                      <ul>
                        <li>
                          <a href="#">
                            <i className="fab fa-facebook-f"></i>
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fab fa-twitter"></i>
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fab fa-typo3"></i>
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fab fa-staylinked"></i>
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fab fa-tumblr"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="binduz-er-blog-post-prev-next d-flex justify-content-between align-items-center">
                    <div className="binduz-er-post-prev-next">
                      <a href="#">
                        <span>{item.prpo}</span>
                        <h4 className="binduz-er-title">{item.prpo1}</h4>
                      </a>
                    </div>
                    <div className="binduz-er-post-prev-next text-end">
                      <a href="#">
                        <span>{item.np}</span>
                        <h4 className="binduz-er-title">{item.np1}</h4>
                      </a>
                    </div>
                    <div className="binduz-er-post-bars">
                      <a href="#">
                        {/* <img
                          src={
                            require(`../../../assets/images/icon/post-bars.png`)
                              .default
                          }
                          alt=""
                        /> */}
                        <img src={postbar} alt="" />
                      </a>
                    </div>
                  </div>
                  <div className="binduz-er-blog-related-post">
                    <div className="binduz-er-related-post-title">
                      <h3 className="binduz-er-title">{item.head1}</h3>
                    </div>
                    <div className="binduz-er-blog-related-post-slide">
                      <SliderCom settings={settings}>
                        <div className="binduz-er-video-post binduz-er-recently-viewed-item">
                          <div className="binduz-er-latest-news-item">
                            <div className="binduz-er-thumb">
                              <img
                                src={
                                  require(`../../../assets/images/editors-pack-thumb-1.jpg`)
                                    .default
                                }
                                alt=""
                              />
                            </div>
                            <div className="binduz-er-content">
                              <div className="binduz-er-meta-item">
                                <div className="binduz-er-meta-categories">
                                  <a href="#">{item.news}</a>
                                </div>
                                <div className="binduz-er-meta-date">
                                  <span>
                                    <i className="fal fa-calendar-alt"></i>{item.date}
                                  </span>
                                </div>
                              </div>
                              <h5 className="binduz-er-title">
                                <a href="#">
                                  {item.p10}
                                </a>
                              </h5>
                            </div>
                          </div>
                        </div>
                        <div className="binduz-er-video-post binduz-er-recently-viewed-item">
                          <div className="binduz-er-latest-news-item">
                            <div className="binduz-er-thumb">
                              <img
                                src={
                                  require(`../../../assets/images/editors-pack-thumb-2.jpg`)
                                    .default
                                }
                                alt=""
                              />
                            </div>
                            <div className="binduz-er-content">
                              <div className="binduz-er-meta-item">
                                <div className="binduz-er-meta-categories">
                                  <a href="#">{item.news}</a>
                                </div>
                                <div className="binduz-er-meta-date">
                                  <span>
                                    <i className="fal fa-calendar-alt"></i>{item.date1}
                                  </span>
                                </div>
                              </div>
                              <h5 className="binduz-er-title">
                                <a href="#">
                                  {item.p11}
                                </a>
                              </h5>
                            </div>
                          </div>
                        </div>
                        <div className="binduz-er-video-post binduz-er-recently-viewed-item">
                          <div className="binduz-er-latest-news-item">
                            <div className="binduz-er-thumb">
                              <img
                                src={
                                  require(`../../../assets/images/editors-pack-thumb-3.jpg`)
                                    .default
                                }
                                alt=""
                              />
                            </div>
                            <div className="binduz-er-content">
                              <div className="binduz-er-meta-item">
                                <div className="binduz-er-meta-categories">
                                  <a href="#">{item.news}</a>
                                </div>
                                <div className="binduz-er-meta-date">
                                  <span>
                                    <i className="fal fa-calendar-alt"></i>{item.date2}
                                  </span>
                                </div>
                              </div>
                              <h5 className="binduz-er-title">
                                <a href="#">
                                  {item.p12}
                                </a>
                              </h5>
                            </div>
                          </div>
                        </div>
                        <div className="binduz-er-video-post binduz-er-recently-viewed-item">
                          <div className="binduz-er-latest-news-item">
                            <div className="binduz-er-thumb">
                              <img
                                src={
                                  require(`../../../assets/images/editors-pack-thumb-4.jpg`)
                                    .default
                                }
                                alt=""
                              />
                            </div>
                            <div className="binduz-er-content">
                              <div className="binduz-er-meta-item">
                                <div className="binduz-er-meta-categories">
                                  <a href="#">{item.news}</a>
                                </div>
                                <div className="binduz-er-meta-date">
                                  <span>
                                    <i className="fal fa-calendar-alt"></i>{item.date3}
                                  </span>
                                </div>
                              </div>
                              <h5 className="binduz-er-title">
                                <a href="#">
                                  {item.p13}
                                </a>
                              </h5>
                            </div>
                          </div>
                        </div>
                      </SliderCom>
                    </div>
                  </div>
                  <div className="binduz-er-blog-post-form">
                    <form action="#">
                      <div className="binduz-er-blog-post-title">
                        <h3 className="binduz-er-title">{item.postp}</h3>
                      </div>
                      <div className="row">
                        <div className=" col-lg-6">
                          <div className="binduz-er-input-box">
                            <input type="text" placeholder="Enter full name" />
                          </div>
                          <div className="binduz-er-input-box">
                            <input type="email" placeholder="Email address" />
                          </div>
                          <div className="binduz-er-input-box">
                            <div className="binduz-er-input-box binduz-er-select-item">
                              <DropDown
                                datas={category1}
                                selected={selectedCategory}
                                action={changeCategory1}
                                className="mexuvo-binduz-tech-dropdown"
                              />
                            </div>
                          </div>
                        </div>
                        <div className=" col-lg-6">
                          <div className="binduz-er-input-box">
                            <textarea
                              name="#"
                              id="#"
                              cols="30"
                              rows="10"
                              placeholder="Enter message"
                            ></textarea>
                          </div>
                        </div>
                        <div className=" col-lg-12">
                          <div className="binduz-er-input-box text-end mt-15">
                            <button
                              type="button"
                              className="binduz-er-main-btn"
                            >
                              {item.postc}
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div className=" col-lg-3">
              <div className="binduz-er-populer-news-sidebar">
                <div className="binduz-er-archived-sidebar-about">
                  <div className="binduz-er-user">
                    <img
                      src={
                        require(`../../../assets/images/archived-about.png`)
                          .default
                      }
                      alt=""
                    />
                    <div className="binduz-er-icon">
                      <i className="fal fa-newspaper"></i>
                    </div>
                  </div>
                  <span>{item.sr}</span>
                  <h4 className="binduz-er-title">{item.author2}</h4>
                  <ul>
                    <li>
                      <a href="#">
                        <i className="fab fa-facebook-f"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fab fa-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fab fa-behance"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fab fa-youtube"></i>
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="binduz-er-author-sidebar-search-bar">
                  <form action="#">
                    <div className="binduz-er-input-box">
                      <input type="text" placeholder="Search from here..." />
                      <button type="button">
                        <i className="fal fa-search"></i>
                      </button>
                    </div>
                  </form>
                </div>

                <div className="binduz-er-populer-news-sidebar-post pt-40">
                  <div className="binduz-er-popular-news-title">
                    <ul
                      className="nav nav-pills mb-3"
                      id="pills-tab-2"
                      role="tablist"
                    >
                      <li className="nav-item" role="presentation">
                        <a
                          className="nav-link active"
                          id="pills-home-tab"
                          data-bs-toggle="pill"
                          href="#pills-home"
                          role="tab"
                          aria-controls="pills-home"
                          aria-selected="true"
                        >
                          {item.mp}
                        </a>
                      </li>
                      {/* <li className="nav-item" role="presentation">
                        <a
                          className="nav-link"
                          id="pills-profile-tab"
                          data-bs-toggle="pill"
                          href="#pills-profile"
                          role="tab"
                          aria-controls="pills-profile"
                          aria-selected="false"
                        >
                          Most Recent
                        </a>
                      </li> */}
                    </ul>
                  </div>
                  <div className="tab-content" id="pills-tabContent-2">
                    <div
                      className="tab-pane fade show active"
                      id="pills-home"
                      role="tabpanel"
                      aria-labelledby="pills-home-tab"
                    >
                      <div className="binduz-er-sidebar-latest-post-box">
                        <div className="binduz-er-sidebar-latest-post-item">
                          <div className="binduz-er-thumb">
                            {/* <img
                              src={
                                require(`../../../assets/images/latest-post-1.jpg`)
                                  .default
                              }
                              alt="latest"
                            /> */}
                            <img src={latestp1} alt="" />
                          </div>
                          <div className="binduz-er-content">
                            <span>
                              <i className="fal fa-calendar-alt"></i> {item.date4}
                            </span>
                            <h4 className="binduz-er-title">
                              <a href="#">
                                {item.p14}
                              </a>
                            </h4>
                          </div>
                        </div>
                        <div className="binduz-er-sidebar-latest-post-item">
                          <div className="binduz-er-thumb">
                            {/* <img
                              src={
                                require(`../../../assets/images/latest-post-2.jpg`)
                                  .default
                              }
                              alt="latest"
                            /> */}
                            <img src={latestp2} alt="" />
                          </div>
                          <div className="binduz-er-content">
                            <span>
                              <i className="fal fa-calendar-alt"></i> {item.date5}
                            </span>
                            <h4 className="binduz-er-title">
                              <a href="#">
                                {item.p15}
                              </a>
                            </h4>
                          </div>
                        </div>
                        <div className="binduz-er-sidebar-latest-post-item">
                          <div className="binduz-er-thumb">
                            {/* <img
                              src={
                                require(`../../../assets/images/latest-post-3.jpg`)
                                  .default
                              }
                              alt="latest"
                            /> */}
                            <img src={latestp3} alt="" />
                          </div>
                          <div className="binduz-er-content">
                            <span>
                              <i className="fal fa-calendar-alt"></i>{item.date6}
                            </span>
                            <h4 className="binduz-er-title">
                              <a href="#">
                                {item.p16}
                              </a>
                            </h4>
                          </div>
                        </div>
                        <div className="binduz-er-sidebar-latest-post-item">
                          <div className="binduz-er-thumb">
                            {/* <img
                              src={
                                require(`../../../assets/images/latest-post-4.jpg`)
                                  .default
                              }
                              alt="latest"
                            /> */}
                            <img src={newyear} alt="" />
                          </div>
                          <div className="binduz-er-content">
                            <span>
                              <i className="fal fa-calendar-alt"></i>{item.date7} 
                            </span>
                            <h4 className="binduz-er-title">
                              <a href="#">
                                {item.p17}
                              </a>
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div
                      className="tab-pane fade"
                      id="pills-profile"
                      role="tabpanel"
                      aria-labelledby="pills-profile-tab"
                    >
                      <div className="binduz-er-sidebar-latest-post-box">
                        <div className="binduz-er-sidebar-latest-post-item">
                          <div className="binduz-er-thumb">
                            <img
                              src={
                                require(`../../../assets/images/latest-post-1.jpg`)
                                  .default
                              }
                              alt="latest"
                            />
                          </div>
                          <div className="binduz-er-content">
                            <span>
                              <i className="fal fa-calendar-alt"></i> 24th
                              February 2020
                            </span>
                            <h4 className="binduz-er-title">
                              <a href="#">
                                Why creating inclusive classrooms matters
                              </a>
                            </h4>
                          </div>
                        </div>
                        <div className="binduz-er-sidebar-latest-post-item">
                          <div className="binduz-er-thumb">
                            <img
                              src={
                                require(`../../../assets/images/latest-post-2.jpg`)
                                  .default
                              }
                              alt="latest"
                            />
                          </div>
                          <div className="binduz-er-content">
                            <span>
                              <i className="fal fa-calendar-alt"></i> 24th
                              February 2020
                            </span>
                            <h4 className="binduz-er-title">
                              <a href="#">
                                Celebrating Asian Pacific American art and
                              </a>
                            </h4>
                          </div>
                        </div>
                        <div className="binduz-er-sidebar-latest-post-item">
                          <div className="binduz-er-thumb">
                            <img
                              src={
                                require(`../../../assets/images/latest-post-3.jpg`)
                                  .default
                              }
                              alt="latest"
                            />
                          </div>
                          <div className="binduz-er-content">
                            <span>
                              <i className="fal fa-calendar-alt"></i> 24th
                              February 2020
                            </span>
                            <h4 className="binduz-er-title">
                              <a href="#">
                                From overcoming burnout to finding new
                              </a>
                            </h4>
                          </div>
                        </div>
                        <div className="binduz-er-sidebar-latest-post-item">
                          <div className="binduz-er-thumb">
                            <img
                              src={
                                require(`../../../assets/images/latest-post-4.jpg`)
                                  .default
                              }
                              alt="latest"
                            />
                          </div>
                          <div className="binduz-er-content">
                            <span>
                              <i className="fal fa-calendar-alt"></i> 24th
                              February 2020
                            </span>
                            <h4 className="binduz-er-title">
                              <a href="#">
                                Sparks of inspiration to the new trend 2021
                              </a>
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>

                <div className="binduz-er-populer-news-sidebar-newsletter binduz-er-author-page-newsletter mt-40">
                  <div className="binduz-er-newsletter-box text-center">
                    <img
                      src={
                        require(`../../../assets/images/icon/icon-3.png`)
                          .default
                      }
                      alt=""
                    />
                    <h3 className="binduz-er-title">{item.sc}</h3>
                    <p>{item.sc2}</p>
                    <div className="binduz-er-input-box">
                      <input type="text" placeholder="Enter your email" />
                      <button type="button">
                        <i className="fal fa-long-arrow-right"></i>
                      </button>
                    </div>
                  </div>
                </div>

                {/* <div className="binduz-er-populer-news-social binduz-er-author-page-social mt-40">
                  <div className="binduz-er-popular-news-title">
                    <h3 className="binduz-er-title">{item.socialcon}</h3>
                  </div>
                  <div className="binduz-er-social-list">
                    <div className="binduz-er-list">
                      <a href="#">
                        <span>
                          <i className="fab fa-facebook-f"></i>
                          <span>{item.likec}</span> {item.like}
                        </span>
                        <span>{item.like}</span>
                      </a>
                      <a href="#">
                        <span>
                          <i className="fab fa-twitter"></i> <span>{item.likec}</span>
                          {item.like}
                        </span>
                        <span>{item.twitter}</span>
                      </a>
                      <a href="#">
                        <span>
                          <i className="fab fa-behance"></i> <span>{item.view}</span>
                          {item.followers}
                        </span>
                        <span>{item.follow}</span>
                      </a>
                      <a href="#">
                        <span>
                          <i className="fab fa-youtube"></i> <span>{item.likec}</span>
                          {item.subscribe}
                        </span>
                        <span>{item.subscribe}</span>
                      </a>
                    </div>
                  </div>
                </div> */}

                <div className="binduz-er-populer-news-social binduz-er-author-page-social mt-40">
                  <div className="binduz-er-popular-news-title">
                    <h3 className="binduz-er-title">{item.videop}</h3>
                  </div>
                  <div className="binduz-er-video-post binduz-er-recently-viewed-item">
                    <div className="binduz-er-latest-news-item">
                      <div className="binduz-er-thumb">
                        <img
                          src={
                            require(`../../../assets/images/editors-pack-thumb-1.jpg`)
                              .default
                          }
                          alt=""
                        />
                        <div className="binduz-er-play">
                          <a href="#">
                            <i className="fas fa-play"></i>
                          </a>
                        </div>
                      </div>
                      <div className="binduz-er-content">
                        <div className="binduz-er-meta-item">
                          <div className="binduz-er-meta-categories">
                            <a href="#">{item.news}</a>
                          </div>
                          <div className="binduz-er-meta-date">
                            <span>
                              <i className="fal fa-calendar-alt"></i>{item.date8}
                            </span>
                          </div>
                        </div>
                        <h5 className="binduz-er-title">
                          <a href="#">
                            {item.p18}
                          </a>
                        </h5>
                        <div className="binduz-er-meta-author">
                          <span>
                            <span>{item.author}</span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="binduz-er-sidebar-social binduz-er-populer-news-sidebar-add d-none d-lg-block">
                  <div className="binduz-er-sidebar-add mt-40">
                    <h3 className="binduz-er-title">
                      {item.business1} <span>{item.business2}</span>
                    </h3>
                    <a className="binduz-er-main-btn" href="#">
                      {item.purchase}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )})}
      </section>
    </>
  );
}

export default AuthorSection;
